import { SFF_MENU_ITEMS } from '../constants';
import { MerchantItem, LocationItem, Menu } from '../interface';

export const getPageNameByPath = (path: string): string | undefined => {
  for (const category of SFF_MENU_ITEMS.MERCHANT) {
    const items = (category as Menu<MerchantItem>).items;
    if (!items) continue;
    const item = items.find((i) => i.link === path || i.links?.includes(path));
    if (item) return item.label;
  }

  for (const category of SFF_MENU_ITEMS.LOCATION) {
    const items = (category as Menu<LocationItem>).items;
    if (!items) continue;
    const item = items.find((i) => i.link === path);
    if (item) return item.label;
  }

  return undefined;
};
